import { useState } from 'react';

export const useDateTimeFormat = () => {
    const [isRelative, setIsRelative] = useState(true);

    const toggleFormat = () => {
        setIsRelative(!isRelative);
    };

    return {
        isRelative,
        toggleFormat,
    };
};
